<div class="breadcrumb-container">
  <ds-breadcrumbs [breadcrumbs]="breadcrumbs" [collapsable]="false" [iconStyle]="isMobile ? 'material-icons-outlined' : null"></ds-breadcrumbs>
</div>

@if (!isMobile) {
  <div class="header-container">
    <div class="header-title">
      <div class="title-container">
        <typography id="accountTitle" variant="mat-headline-4" weight="bold">{{ appStrings.contacts_accountDetails }}</typography>
        <typography id="accountSeparator" variant="mat-headline-4" weight="bold">|</typography>
        <typography id="accountName" variant="mat-headline-4" weight="bold">
          {{accountName1}} {{accountName2}}
        </typography>
      </div>
      <ds-chip id="bpNumber" class="selectable-chip" variant="filled" size="medium">{{appStrings.quote_bpLabel}}: {{ bpNumber }}</ds-chip>
    </div>
    <div class="header-buttons">
      @if (leadDetails) {
        <ds-button id="editLeadButton"
          size="large" type="primary" variant="label-only" [label]="appStrings.label_edit_lead"
          (onClick)="editLead()">
        </ds-button>
      }
      <ds-button id="backButton" size="large" type="secondary"
        variant="label-only" [label]="appStrings.button_back" (onClick)="goBack()">
      </ds-button>
    </div>
  </div>
}

<div [ngClass]="!leadDetails ? 'content' : 'mobile-lead-content'">
  @if (isMobile) {
    <div id="title" class="title">
      <typography id="accountTitle" variant="mat-headline-4" weight="bold">
        {{accountName1}} {{accountName2}}
      </typography>
      <div>
        <typography id="bpLabel" variant="mat-body-2" weight="bold">
          {{appStrings.quote_bpLabel}}:
        </typography>
        <typography id="bpNumber" variant="mat-body-2" weight="regular">
          {{bpNumber}}
        </typography>
      </div>
    </div>
  }

  <div class="toggle-container" [ngClass]="{'mobile': isMobile}">
    <ds-button-toggle-legacy
      [toggleValues]="toggleValues"
      size="large"
      type="outlined"
      [selectedIndex]="selectedToggleIndex"
      (onClick)="updateTab($event.index)"
    ></ds-button-toggle-legacy>

    @if (selectedTab === 2) {
      <div class="add-new-contact">
        <ds-button id="newContact" variant="primary" type="label-only" label="{{appStrings.contacts_newContact}}"
          (onClick)="onNewContactClick()" size="large">
        </ds-button>
      </div>
    }
  </div>

  <!-- Dashboard Tab -->
  @if (selectedTab === 0) {
    <ng-container id="customerDashboardTab">
      @if (customerDetails || leadDetails) {
        <app-accounts-info-widget id="customerDetails"
          [customerInfo]="customerDetails" [leadInfo]="leadDetails">
        </app-accounts-info-widget>
      }
      @if (isOnline && (customerDetails || leadDetails)) {
        <div>
          <app-daily-touchpoints (activeTab)="updateTab($event)" [customerId]="customerId" [leadId]="leadId"
            [accountManagerEmployeeId]="customerDetails?.employeeId || leadDetails?.employeeId">
          </app-daily-touchpoints>
        </div>
      }
      <app-quotes-widget [customerId]="customerId" [leadId]="leadId" [customerName]="accountName1 + ' ' + accountName2"
        (loaded)="onQuotesLoaded()"></app-quotes-widget>
      @if (isOnline) {
        <div>
          @if (accountId) {
            <app-notes-widget #notesWidget [accountId]="accountId" [canOpenTouchpoints]="canOpenTouchpoints"
              (loaded)="onNotesLoaded()" (openTouchpoint)="openTouchpointFromNote($event)">
            </app-notes-widget>
          }
        </div>
      }
    </ng-container>
  }

  <!-- B2B Users Tab -->
  @if (isOnline && selectedTab === 1) {
    <ng-container id="b2bUsersTab">
      @if (accountIsLoaded) {
        <app-b2b-users [canEdit]="canEdit" [bpNumber]="bpNumber" [countryCodeId]="customerCountryCode"></app-b2b-users>
      }
    </ng-container>
  }

  <!-- Contacts Tab -->
  @if (isOnline && selectedTab === 2) {
    <ng-container id="contactsTab">
      @if (accountIsLoaded) {
        <app-contacts-list [canEdit]="canEdit"></app-contacts-list>
      }
    </ng-container>
  }

  <!-- Touchpoints Tab -->
  @if (isOnline && selectedTab === 3 && (customerDetails || leadDetails)) {
    <ng-container id="touchpointsTab">
      <app-daily-touchpoints (activeTab)="updateTab($event)" [customerId]="customerId" [leadId]="leadId"
        [accountManagerEmployeeId]="customerDetails?.employeeId || leadDetails?.employeeId">
      </app-daily-touchpoints>
    </ng-container>
  }

  <!-- Transaction History Tab -->
  @if (customerId && selectedTab === 4) {
    <ng-container id="transactionHistoryTab">
      @if (bpNumber) {
        <app-order-list [isOnAccountsPage]="true" [bpNumber]="bpNumber"></app-order-list>
      }
    </ng-container>
  }

  <!-- Invoices Tab -->
  @if (customerId && isOnline && selectedTab === 5) {
    <ng-container id="invoicesTab">
      @if (bpNumber) {
        <app-invoices-list [isOnAccountsPage]="true" [bpNumber]="bpNumber"></app-invoices-list>
      }
    </ng-container>
  }

  <!-- LN Orders Tab -->
  @if (customerId && isOnline && selectedTab === 6) {
    <ng-container id="lnOrderTab">
      @if (bpNumber) {
        <app-ln-order-list [isOnAccountsPage]="true" [bpNumber]="bpNumber"></app-ln-order-list>
      }
    </ng-container>
  }
</div>

@if (leadDetails && isMobile) {
  <div class="mobile-sticky-footer">
    <ds-button id="editLeadButton"
      size="large" type="primary" variant="label-only" [label]="appStrings.label_edit_lead"
      (onClick)="editLead()">
    </ds-button>
  </div>
}